import { store } from '../store'

export const uiHelper = {
  responseMessage,
  canUse,
  getActiveRole,
  byteToMega,
  percentage
}

function responseMessage (code) {
  switch (code) {
    case 501:
      return 'Sono state trovate più di 20.000 anomalie, migliora i filtri di ricerca'
    default:
      return 'Error'
  }
}

function canUse (index) {
  const r = this.getActiveRole()
  return (r.permission[index] === '1')
}

// function canUse (minPerm) {
//   const profile = store.getState().profile
//   if (profile === null) { return false }
//   const roleid = profile.roleid
//   if (roleid === null) { return false }
//   return (minPerm.filter(x => x === roleid).length > 0)
// }

function getActiveRole () {
  const profile = store.getState().profile
  if (profile === null) { return false }
  const roles = profile.roles
  if (roles === null) { return false }
  const ar = roles.filter(x => x.isActive === 1)
  if (ar.length > 0) {
    return ar[0]
  }
  return null
}

function byteToMega (val, unit = ' MB') {
  return (val / 1000000).toFixed(2) + unit
}

function percentage (t, p, width = 100) {
  if (t === p) {
    return 100
  }
  return parseInt((width * p) / t).toFixed()
}
